// should this be moved to fe-design-system as an option on Text?

import { Children } from 'react';
import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change-corgi/design-system-legacy/typography';

import type { PropsWithSyncChildren, SyncReactNode } from 'src/app/shared/types';

export const TextNl2Br: React.FC<PropsWithSyncChildren<ComponentProps<typeof Text>>> = ({ children, ...rest }) => {
	const childrenAsArray = Children.toArray(children);

	return <Text {...rest}>{childrenAsArray.map((child) => nl2br(child as SyncReactNode))}</Text>;
};

const NEWLINE_REGEX = /(\r\n|\r|\n)/g;

function nl2br(str: SyncReactNode) {
	if (typeof str !== 'string') {
		return str;
	}

	return str.split(NEWLINE_REGEX).map((line, index) => {
		if (line.match(NEWLINE_REGEX)) {
			// eslint-disable-next-line react/no-array-index-key
			return <br key={index} />;
		}
		return line;
	});
}
